import { render, staticRenderFns } from "./projectChart.vue?vue&type=template&id=a77a11ca&"
import script from "./projectChart.vue?vue&type=script&lang=js&"
export * from "./projectChart.vue?vue&type=script&lang=js&"
import style0 from "./projectChart.vue?vue&type=style&index=0&id=a77a11ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports